import React, { FC } from 'react';
import { IonItem, IonIcon, IonLabel } from '@ionic/react';

export interface AllieMenuItemProps {
  href?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  mode?: 'ios' | 'md';
  button?: boolean;
  disabled?: boolean;
  iosIcon?: string;
  mdIcon?: string;
  customIcon?: React.ReactNode;
  label?: string;
  slot?: string;
  lines?: 'none' | 'inset' | 'full';
  'data-testid'?: string;
}

/**
 * AllieMenuItem - Wrapper around IonItem for menu items
 * Provides consistent menu item styling and behavior
 */
export const AllieMenuItem: FC<AllieMenuItemProps> = ({
  href,
  onClick,
  children,
  className,
  mode = 'md',
  button = true,
  disabled = false,
  iosIcon,
  mdIcon,
  customIcon,
  label,
  slot,
  lines = 'none',
  'data-testid': dataTestId,
}) => {
  const renderIcon = () => {
    if (customIcon) {
      return customIcon;
    }
    if (iosIcon && mdIcon) {
      return <IonIcon slot="start" ios={iosIcon} md={mdIcon} />;
    }
    return null;
  };

  return (
    <IonItem
      href={href}
      onClick={onClick}
      className={className}
      mode={mode}
      button={button}
      disabled={disabled}
      slot={slot}
      lines={lines}
      data-testid={dataTestId}
    >
      {renderIcon()}
      {label && <IonLabel className="menu-link-group">{label}</IonLabel>}
      {children}
    </IonItem>
  );
};

AllieMenuItem.displayName = 'AllieMenuItem';
